import { Component, type ReactNode } from 'react';

interface Props {
  content: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class MarkdownErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm font-medium text-red-800 mb-2">Failed to render this Markdown section.</p>
          <pre className="bg-white p-3 rounded border border-red-100 overflow-x-auto text-sm text-red-900">
            {this.props.content}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
